module.exports = __webpack_public_path__ + "img/cancel.860f1a8f.png";